export default function SendButton({ color }) {
  return (
    <button
      style={{
        alignItems: "center",
        backgroundColor: color,
        border: "none",
        borderRadius: "50%",
        cursor: "pointer",
        display: "flex",
        height: "2.5rem",
        justifyContent: "center",
        width: "2.8rem",
      }}
    >
      <svg
        fill="none"
        height="50"
        viewBox="0 0 50 50"
        width="50"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="25" cy="25" fill={color} r="25" />
        <g filter="url(#filter0_dd_0_1)">
          <path
            clipRule="evenodd"
            d="M26.7365 35.4167C26.7146 35.4167 26.6938 35.4156 26.6729 35.4146C26.2021 35.3865 25.8094 35.0448 25.7156 34.5823L24.1136 26.7C24.0302 26.2896 23.7104 25.9698 23.3 25.8865L15.4177 24.2833C14.9552 24.1906 14.6136 23.7979 14.5854 23.3271C14.5573 22.8552 14.8479 22.424 15.2958 22.276L31.9625 16.7208C32.3365 16.5938 32.749 16.6917 33.0281 16.9719C33.3073 17.251 33.4042 17.6635 33.2802 18.0375L27.724 34.7042C27.5823 35.1323 27.1823 35.4167 26.7365 35.4167"
            fill="#231F20"
            fillRule="evenodd"
          />
          <mask
            height="20"
            id="mask0_0_1"
            maskUnits="userSpaceOnUse"
            style={{
              maskType: "alpha",
            }}
            width="20"
            x="14"
            y="16"
          >
            <path
              clipRule="evenodd"
              d="M26.7365 35.4167C26.7146 35.4167 26.6938 35.4156 26.6729 35.4146C26.2021 35.3865 25.8094 35.0448 25.7156 34.5823L24.1136 26.7C24.0302 26.2896 23.7104 25.9698 23.3 25.8865L15.4177 24.2833C14.9552 24.1906 14.6136 23.7979 14.5854 23.3271C14.5573 22.8552 14.8479 22.424 15.2958 22.276L31.9625 16.7208C32.3365 16.5938 32.749 16.6917 33.0281 16.9719C33.3073 17.251 33.4042 17.6635 33.2802 18.0375L27.724 34.7042C27.5823 35.1323 27.1823 35.4167 26.7365 35.4167"
              fill="white"
              fillRule="evenodd"
            />
          </mask>
          <g mask="url(#mask0_0_1)">
            <rect fill="white" height="25" width="25" x="12.5" y="12.5" />
          </g>
        </g>
      </svg>
    </button>
  );
}
